export enum PersistentStorageKey {
	AppSettings = "appSettingsStorage",
	AppCache = "appCacheStorage",
	Navigation = "navigationStorage",
	Permissions = "permissionsStorage",
	DebugStorage = "debugStorage",
}
